module.exports = __webpack_public_path__ + "img/HU.6c061beb.png";